const registeredGraphs = new Set();

export function registerGraph(graph) {
    if (graph) {
        registeredGraphs.add(graph);
    }
}

export function unregisterGraph(graph) {
    registeredGraphs.delete(graph);
}

export function getRegisteredGraphs({ liveOnly = false } = {}) {
    const result = [];
    registeredGraphs.forEach((graph) => {
        if (!graph || !graph.dom) {
            registeredGraphs.delete(graph);
            return;
        }
        if (liveOnly && !graph.dom.isConnected) {
            registeredGraphs.delete(graph);
            return;
        }
        result.push(graph);
    });
    return result;
}

export function disposeGraphsInScope(root) {
    if (!root) {
        return;
    }

    getRegisteredGraphs().forEach((graph) => {
        if (graph.dom && root.contains(graph.dom)) {
            graph.dispose();
        }
    });

    if (typeof echarts === "undefined") {
        return;
    }

    const nodes = [];
    if (root.matches && root.matches(".dashgraph, .dashgraphZoomed")) {
        nodes.push(root);
    }
    if (root.querySelectorAll) {
        root.querySelectorAll(".dashgraph, .dashgraphZoomed").forEach((node) => nodes.push(node));
    }
    nodes.forEach((node) => {
        const chart = echarts.getInstanceByDom(node);
        if (chart) {
            chart.dispose();
        }
    });
}
